'use client';

import Link from 'next/link';
import classes from './HorizontalTextCard.module.scss';
import { Button, Container } from '@mantine/core';
import { useAOS } from '@/src/lib/hooks/useAOS';
import { Title } from '../../Title/Title';

type HorizontalTextCardProps = {
  title: string;
  description: string;
  backgroundGradient: string;
  button: string;
  buttonColor: string;
  buttonHref: string;
  version: string;
};

export const HorizontalTextCard = ({ data }: { data: HorizontalTextCardProps }) => {
  const { title, description, button, buttonHref, version } = data;
  useAOS();

  return (
    <div
      className={`${classes.fullWidthWrapper} ${version === 'dark' && classes.dark}`}
      data-aos="fade-up"
    >
      <Container>
        <section className={classes.horizontalSection}>
          <h2>{title}</h2>
          <img
            src="https://ik.imagekit.io/hg5cblo5w/articles/separator_resized_compressed%20(1).webp?updatedAt=1749498987481"
            alt="Separation"
            className={`${classes.horizontalSectionDivider} mb-5`}
          />
          <p>{description}</p>
          <Button
            className={classes.button}
            component={Link}
            href={buttonHref ?? ''}
            my="lg"
            data-aos="zoom-in"
          >
            {button}
          </Button>
        </section>
      </Container>
    </div>
  );
};
